module.exports = __webpack_public_path__ + "img/img_new.d1166256.png";